export default {"src":"/_next/static/media/linkedin.cea69da6.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};